export default __webpack_public_path__ + "static/property-monitor-white-f675c57c2065070d49991f07089cc5d2.png";